module.exports = __webpack_public_path__ + "static/fit-82eea52de6dfc8302cd978d9f4dbbe4b.png";